<template>
  <div class="container">
    <!-- <div style="height: 262px;width: 100%;background: linear-gradient(0deg, #0E0F34 0%, #12153D 49%, #0E1036 100%);z-index: 2"></div> -->
    <div class="content"></div>
    <div class="content2" v-if="classId != 46">
      <div class="lc card">
        <div class="car-title">
          <span>学习流程</span>
        </div>
        <div class="ic-contain card-box">
          <div class="lc-item">
            <img src="@/assets/image/two (5).png" alt="" />
            <span>报名</span>
          </div>
          <div class="jian">
            <img src="@/assets/image/two (4).png" alt="" class="jt1" />
          </div>
          <div class="lc-item">
            <img src="@/assets/image/two (3).png" alt="" />
            <span>听课学习</span>
          </div>
          <div class="jian">
            <img src="@/assets/image/two (4).png" alt="" class="jt1" />
          </div>
          <div class="lc-item">
            <img src="@/assets/image/two (2).png" alt="" />
            <span>参加考试</span>
          </div>
          <div class="jian">
            <img src="@/assets/image/two (4).png" alt="" class="jt1" />
          </div>
          <div class="lc-item">
            <img src="@/assets/image/two (1).png" alt="" />
            <span>打印证书</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content3 card">
      <div class="car-title">
        <span>当前学习课程</span>
      </div>
      <div>
        <div
          style="
            background: #ffecd3;
            display: flex;
            justify-content: space-between;
            padding: 14px 20px;
            margin-bottom: 20px;
            margin-top: 14px;
          "
        >
          <div class="sm">
            <span
              >学习要求：必修课学满{{ classinfo.bxHours }}学时{{
                classinfo.xxHours == 0 || classinfo.xxHours == undefined
                  ? ""
                  : `，选修课学满${classinfo.xxHours}学时`
              }}</span
            >
            <span
              >完成说明：{{
                classinfo.needPaper ? "需要考试" : "不需要考试"
              }}</span
            >
            <span>实际学习：总学时已完成{{ totalHours }}学时</span>
          </div>
          <div style="margin-top: 10px">
            <el-button
              v-show="classinfo.testId != 0"
              style="
                font-size: 14px;
                font-weight: 400;
                color: #f00;
                background: #dc964f;
              "
              @click="toTest(classinfo.testId, classId)"
            >
              考前测试
            </el-button>
            <el-button
              v-show="classinfo.needPaper"
              style="
                font-size: 14px;
                font-weight: 400;
                color: #fff;
                background: #dc964f;
                border: none;
              "
              @click="toTest(paperId, classId)"
            >
              参加考试
            </el-button>
          </div>
        </div>
      </div>
      <div>
        <el-table border :data="userCourseList">
          <el-table-column prop="courseName" align="center" label="课程名称">
          </el-table-column>
          <el-table-column
            prop="courseType"
            align="center"
            label="类型"
            width="180"
          >
          </el-table-column>
          <el-table-column prop="coursePercent" align="center" label="学习状态">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="clie">
                <div class="caozuo">
                  <span
                    style="
                      color: #264f99;
                      font-size: 14px;
                      font-weight: 400;
                      cursor: pointer;
                    "
                    @click="
                      toListen(
                        scope.row.courseStatus,
                        scope.row.courseId,
                        scope.row.classId
                      )
                    "
                    >{{ scope.row.courseStatus }}</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="coursePercent" align="center" label="课件">
            <template slot-scope="scope">
              <div class="ansnsCon">
                <p
                  class="anasj"
                  v-for="item in scope.row.anenes"
                  :key="item.attachmentId"
                  @click="deait(item.url)"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.name"
                    placement="top"
                  >
                    <div class="snasifle">
                      <img src="@/assets/image/FILE.png" />
                    </div>
                  </el-tooltip>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="content3 card">
      <div class="car-title">
        <span>选修课程</span>
      </div>
      <div style="margin-top: 14px">
        <el-table border :data="xxList">
          <el-table-column prop="courseName" align="center" label="课程名称">
          </el-table-column>
          <el-table-column
            prop="courseType"
            align="center"
            label="类型"
            width="180"
          >
          </el-table-column>
          <el-table-column prop="courseHours" align="center" label="总学时">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <span
                style="
                  color: #264f99;
                  font-size: 14px;
                  font-weight: 400;
                  cursor: pointer;
                "
                @click="addCourse(scope.row.classCourseId)"
                >选择</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";

export default {
  name: "index",
  data() {
    return {
      userCourseList: [],
      xxList: [],
      paperId: "",
      classId: "",
      classinfo: {},
      totalHours: 0,
    };
  },
  mounted() {
    this.classId = this.$route.query.classId;
    api
      .userCourse(cookie.getCookie("userId"), this.$route.query.classId)
      .then(async (res) => {
        // console.log(this.classId)
        const promises  = res.data.map(async (itm) => {
          if (itm.courseType == 1) {
            itm.courseType = "必修";
          } else if (itm.courseType == 2) {
            itm.courseType = "选修";
            // this.xxList.push(itm)
            // console.log(this.xxList)
          } else {
            itm.courseType = "必修";
          }
          if (Number(itm.coursePercent) == 0) {
            itm.courseStatus = "开始学习";
          } else if (1 > Number(itm.coursePercent) > 0) {
            itm.courseStatus = "继续学习";
          } else {
            itm.courseStatus = "重新学习";
          }
          itm.coursePercent = Math.round(itm.coursePercent * 100)  + "%";
          try {
            const res = await api.getclassConfigSponsor(itm.courseId);
            console.log(res.data, "我是附件");
            itm.anenes = res.data;
          } catch (error) {
            console.error("请求失败:", error);
            // 可以添加错误处理逻辑，例如回退到上一个状态或者显示错误信息等
          }
          if (itm.coursePercent == "100%") {
            this.totalHours += itm.courseHours;
          }
          return itm
        });
         // 使用Promise.all进行批处理，提高性能
        const results = await Promise.all(promises)
        this.userCourseList = results
      });
    api.bxxxCourse(this.classId).then((res) => {
      // console.log(res.data.list)
      res.data.list.map((itm) => {
        if (itm.courseType == 2) {
          itm.courseType = "选修";
          this.xxList.push(itm);
        }
      });
    }),
      api.getClassConfig(this.classId).then((res) => {
        this.paperId = res.data.paperId;
        this.classinfo = res.data;
        // console.log(this.classinfo)
      });
  },
  methods: {
    addCourse(classCourseId) {
      api.getxxClass(classCourseId).then((res) => {
        // if(this.userCourseList.includes(JSON.parse(res.data))){
        //   this.$message.error('不可重复选择')
        // }
        // console.log(this.userCourseList,res.data)
        let classId = res.data.classId;
        let courseId = res.data.courseId;
        let data = {
          classId: classId,
          userId: Number(cookie.getCookie("userId")),
          courseId: courseId,
          coursePercent: 0,
        };
        api.addxxClass(data).then((res) => {
          // console.log(res.data,data)
          // this.xxList.splice(data,1)
          api
            .userCourse(cookie.getCookie("userId"), this.$route.query.classId)
            .then((res) => {
              // console.lo.g(res.data)
              res.data.forEach((itm) => {
                if (itm.courseType == 1) {
                  itm.courseType = "必修";
                } else if (itm.courseType == 2) {
                  itm.courseType = "选修";
                  // this.xxList.push(itm)
                  // console.log(this.xxList)
                } else {
                  itm.courseType = "必修";
                }
                if (Number(itm.coursePercent) == 0) {
                  itm.courseStatus = "开始学习";
                } else if (1 > Number(itm.coursePercent) > 0) {
                  itm.courseStatus = "继续学习";
                } else {
                  itm.courseStatus = "重新学习";
                }
                // console.log(itm.courseStatus)
                itm.coursePercent = Math.round(itm.coursePercent * 100) + "%";
                this.userCourseList.push(itm);
                //  console.log(this.userCourseList)
              });
              this.userCourseList = res.data;
            });
        });
      });
    },
    toListen(courseStatus, id, classId) {
      if (courseStatus == "重新学习") {
        this.$router.push({
          path: "/replay",
          query: { id: id, classId: classId, index: 0 },
        });
      } else {
        this.$router.push({
          path: "/listen",
          query: { id: id, classId: classId, index: 0 },
        });
      }
    },
    toTest(paperId, classId) {
      // console.log(this.userCourseList)
      if (paperId == "" || paperId == null) {
        this.$message({
          type: "error",
          message: "该课程不需要进行考试",
        });
      } else {
        const isGo =  this.userCourseList.every((itm) => {
          return itm.coursePercent == "100%"
        });
        if(isGo){
          this.$router.push({
              path: "/test",
              query: { paperId: paperId, classId: classId },
            });
        } else {
          this.$message({
              type: "error",
              message: "请在课程全部学习完成后再进行考试",
            });
        }
      }
    },
    // 查看附件
    deait(url) {
      window.open(url);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.container {
  background: #f1f5fa;
  .content2 {
    margin-top: 20px;
    text-align: center;
  }
  .content3 {
    width: 1200px;
    margin: 20px auto;
    background: #ffffff;
    //padding: 20px;
    .content3-title {
      display: flex;
      align-items: center;
      padding: 10px 0;
      margin-left: 20px;
    }
    .sm {
      span {
        display: block;
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: #bf7e3c;
        line-height: 22px;
        text-align: left;
      }
    }
  }
}

.clie {
  display: flex;
  align-items: center;
  justify-content: center;
  .caozuo {
    margin-right: 10px;
  }
}

.ansnsCon {
  display: flex;
  flex-direction: row;
  .ansns {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
  }
  .anasj {
    cursor: pointer;
    margin-right: 20px;
    display: flex;
    align-items: center;

    .snasifle {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #264f99;
      background: #f3f7ff;
    }
  }
}

.card {
  width: 1200px;
  background: #ffffff;
  padding: 24px 20px;
  .car-title {
    position: relative;
    text-align: left;
    padding-left: 8px;
    height: 22px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #264f99;
    line-height: 22px;
    text-align: justify;
    font-style: normal;
  }
  .car-title::before {
    content: "";
    width: 4px;
    height: 12px;
    background: #264f99;
    display: block;
    position: absolute;
    top: 6px;
    left: 0px;
  }
}

.lc {
  width: 1200px;
  margin: 0 auto;

  .ic-contain {
    display: flex;
    margin-top: 30px;
    align-items: center;
    .lc-item {
      width: 100%;
      height: 132px;
      background: #f6f7fb;
      border: 1px solid #eaeaeb;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        margin-top: 16px;
      }
    }
    .jian {
      width: 28px;
      height: 10px;
      margin: 0px 10px;
    }
  }
}

::v-deep .has-gutter {
  .el-table__cell {
    background: #f6f7fb;
  }
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
</style>
